import type { InvoiceListFilters } from '../types'

export const buildInvoiceListApiParams = (
  filters: InvoiceListFilters
): URLSearchParams => {
  const params = new URLSearchParams()

  if (filters.companyId) {
    params.append('order.contact.company', filters.companyId.toString())
  }
  if (filters.orderId) {
    params.append('order', filters.orderId.toString())
  }
  if (filters.status) {
    params.append('status', filters.status)
  }
  if (filters.dateFrom) {
    params.append('issuedAt[after]', filters.dateFrom)
  }
  if (filters.dateTo) {
    params.append('issuedAt[before]', filters.dateTo)
  }
  if (filters.dueDateFrom) {
    params.append('dueDate[after]', filters.dueDateFrom)
  }
  if (filters.dueDateTo) {
    params.append('dueDate[before]', filters.dueDateTo)
  }
  if (filters.paymentDateFrom) {
    params.append('paymentDate[after]', filters.paymentDateFrom)
  }
  if (filters.paymentDateTo) {
    params.append('paymentDate[before]', filters.paymentDateTo)
  }
  if (filters.label) {
    params.append('label', filters.label)
  }
  if (filters.externalRef) {
    params.append('externalRef', filters.externalRef)
  }
  if (filters.id) {
    params.append('id', filters.id.toString())
  }
  if (filters.userIds) {
    params.append('order.users', filters.userIds)
  }
  if (filters.sort && filters.sortDirection) {
    params.append(`order[${filters.sort}]`, filters.sortDirection)
  }

  return params
}
